import { RydTimelineSelection } from "../../components/widgets/rolls/RydTimelineHeader";
import { NOTE_WIDTH, tickToPosition } from "../../render/renderUtils";

export function computeTimelineSelectionStyle(
    zoomFactor: number,
    timelineSelection: RydTimelineSelection,
    offset: number
) : React.CSSProperties{
    return {
        position: 'absolute',
        left: `calc(var(--piano-roll-header-width) + ${tickToPosition(NOTE_WIDTH, zoomFactor, timelineSelection.start)}px + 1px - ${offset}px)`,
        width: `${Math.max(1, tickToPosition(NOTE_WIDTH, zoomFactor, timelineSelection.end - timelineSelection.start))}px`,
        border: '1px solid green',
        pointerEvents: 'none',
    }
}